export default "__VITE_ASSET__DOJ8wue7__"